/* @flow weak */
import Glyph from 'components/Glyph.jsx';
import ModalMenuItem from 'components/ModalMenuItem.jsx';
import React from 'react';
import ReportToRemindSelectModal from 'support/components/ReportToRemindSelectModal.jsx';
import Subscriber from 'entities/Subscriber';
import UserActions from 'user/UserActions';

class ReportUserMenuItem extends React.Component {
  static propTypes = {
    reportee: React.PropTypes.instanceOf(Subscriber).isRequired,
  };

  reportParticipant = (reason, notes) => {
    UserActions.reportUser(this.props.reportee.id, reason, notes);
  };

  renderReportDialog = () => {
    return (
      <ReportToRemindSelectModal
        reportee={this.props.reportee.getName()}
        notesPlaceholder="Why are you reporting this participant?"
        onReport={this.reportParticipant}
      />
    );
  };

  render() {
    return (
      <ModalMenuItem {...this.props} modal={this.renderReportDialog()}>
        <Glyph name="flag" />
        <span>
          Report to Remind
        </span>
      </ModalMenuItem>
    );
  }
}

export default ReportUserMenuItem;



// WEBPACK FOOTER //
// ./src/user/components/ReportUserMenuItem.jsx